

export class Button {
    constructor(name, link) {
        this.name = name;
        this.link = link;
    }
}

export class Assignment {
    constructor(name, date, desc, buttons, videos) {
        this.name = name;
        this.date = date;
        this.desc = desc;
        this.buttons = buttons;
        this.videos = videos;
    }
}

export class Exp {

    constructor(name, imageName, position, time, description, projects, buttons) {
        this.name = name;
        this.imageName = imageName;
        this.position = position;
        this.time = time;
        this.description = description;
        this.projects = projects;
        this.buttons = buttons;
    }

    getImage() {
        return this.imageName;
    }

}

export const dscvr = new Assignment(
    "Dscvr",
    "2018",
    "Dscvr is a discount app that allows shops to selectively " +
    "get customers in at certain times. It is a brilliant take on discounts " +
    "that no one has had the gumption to fully do.",
    [
        new Button("View", "https://play.google.com/store/apps/details?id=com.snapsales.dscvr"),
        new Button("Video", "https://gurpreet-.ams3.digitaloceanspaces.com/videos/dscvr.mp4"),
    ],
);

export const fupp = new Assignment(
    "FUPP",
    "2018",
    "I developed a front-end for a recruitment company " +
    "that had an interesting take on recruitment. Designed by an external designer.",
    [
        new Button("Video", "https://gurpreet-.ams3.digitaloceanspaces.com/videos/fupp.mp4"),
    ],
);

export const lazysodium = new Assignment(
    "Lazysodium",
    "2018",
    "Lazysodium is a Libsodium Android / Java binding, which makes it effortless to " +
    "add great cryptography to your applications. Built primarily for Recordo. " +
    "This library is used in many projects. I'm proud to say this library is used by <span class='text-bold'>millions</span> worldwide via " +
    "<a href='https://threema.ch/en'>Threema</a> and a bunch of other <a href='https://docs.lazycode.co/lazysodium/projects'>notable projects</a>.",
    [
        new Button("View", "https://github.com/terl/lazysodium-java"),
        new Button("Play Store", "https://play.google.com/store/apps/details?id=com.goterl.lazycode.lazysodium.example"),
    ]
);

export const recordo = new Assignment(
    "Recordo",
    "2017",
    "Recordo is a cryptographically secure, open-source diary / journal app built on pure Android. " +
    "It's a project from my company, Terl. I have a waiting list of around <span class='text-bold'>60 users</span>.",
    [
        new Button("View", "https://recordo.co"),
        new Button("GitHub", "https://github.com/terl/recordo-android")
    ]
);

export const systraApp = new Assignment(
    "Systra Survey App",
    "2016",
    "I developed and designed a native Android " +
    "survey app which was released around the country to many " +
    "train stations and handed to hundreds of people to" +
    "fill in live. This was a complicated project that required SQLite and proper schema planning.",
    [new Button("Video", "https://gurpreet-.ams3.digitaloceanspaces.com/videos/survey.mp4")]
);

export const googleGlass = new Assignment(
    "Google Glass For Training and Education",
    "2016",
    "My final year project. I got this to a reasonable state. I coded a live streaming Glass App " +
    "which live streamed a video feed to a server and back again. I used raw" +
    "threads but the limitations of Glass proved to be too much to handle.",
    [new Button("Download report", "projects/google_glass.pdf")]
);

export const crimeEye = new Assignment(
    "Crime Eye",
    "2015",
    "This ambitious iOS app was coded within " +
    "3 weeks by me and two other team members. " +
    "The end result? An app that shows you exactly where " +
    "crimes have happened on a map given a postcode you supply.",
    [new Button("View", "https://github.com/crime-eye")]
);


export const tgiu = new Assignment(
    "The Gig Is Up",
    "2015",
    "First large software group project. " +
    "Aim was simple: Create a gig booking system. " +
    "I took the lead on this one, organising scrum meetings " +
    "with the team and working on the website, app and server.",
    [
        new Button("View", "https://github.com/the-gig-is-up"),
        new Button("Download", "projects/tgiu.apk"),
        new Button("Play Store", "https://play.google.com/store/apps/details?id=com.dolphin.thegigisup"),
    ]
);


export const smtwIos = new Assignment(
    "Show Me The Weather (iOS)",
    "2015",
    "This is the iOS version of the Show Me The Weather app. Part of another " +
    "university project.",
    [new Button("View", "https://github.com/gurpreet-/show-me-the-weather-ios")]
);

export const smtwAndroid = new Assignment(
    "Show Me The Weather (Android)",
    "2014",
    "An app I created for a University project. It shows the weather. Created for Android apps.",
    [
        new Button("View", "https://github.com/gurpreet-/show-me-the-weather"),
        new Button("Download", "projects/smtw.apk")
    ]
);

export const mandsIncidents = new Assignment(
    "M&S Incidents",
    "2014",
    "After my previous success with Ionic I was brought in to do it again but this time for M&S. " +
    "I designed and completed an incidents app for M&S which they were very impressed with.",
    []
);

export const intradocChecklists = new Assignment(
    "Intradoc 24/7 Checklists",
    "2014",
    "I developed this as a hybrid app using Ionic. " +
    "I had an immense amount of fun learning Ionic which later " +
    "led me to doing the M&S app.",
    []
);

export const princeTutti = new Assignment(
    "Prince Tutankhamen",
    "2013",
    "This was my first game and first ever dual team university project. " +
    "There was a game on Sky Games called Prince Tutti. " +
    "You got chased by several mummies in mazes. You collected keys " +
    "to progress to the next level. It was fun. So I decided to remake it. " +
    "I did it in PyGame.",
    [new Button("View", "https://github.com/gurpreet-/prince-tutti")],
);

export const mathematrics = new Assignment(
    "Mathematrics",
    "2013",
    "Mathematrics is one of my first ever websites. " +
    "It was quite badly designed but worked. " +
    "It's aim was to teach people tricks in Maths. " +
    "I used Dreamweaver for bits of this and the rest I hand coded.",
    [new Button("View", "https://gitlab.com/gurpreet-/mathematrics")],
);

export const raptshia = new Assignment(
    "Raptshia Games",
    "2012",
    "As part of a project for high school, a fictional company wanted a database. " +
    "I did some programming in VBA to achieve this goal.",
    [new Button("View", "https://gitlab.com/gurpreet-/raptshia-games")],
);

export const l4dDoorLock = new Assignment(
    "L4D Door Lock",
    "2010",
    "As a young teenager, throughout high school, I coded some plugins " +
    "for the Marvelous Gaming community and for L4D2. All done in SourcePawn.",
    [new Button("Download", "projects/l4d_lock.zip")],
);

export const freeagent = new Exp(
    "FreeAgent",
    "freeagent.png",
    "Staff Software Engineer",
    "Jan 2022 to Present",
    <div>
        <p>
            Working 100% remotely as part of a high-performance mobile team to deliver the FreeAgent app that is backed by NatWest, is delivered to over 100,000 customers and is currently rated 4.8⭑! The app uses the latest and greatest such as MVVM, Kotlin + Coroutines, Viewbinding, Jetpack Navigation and its own caching layer.
            As a staff software engineer on the mobile team I am responsible for:
        </p>
        <ul>
            <li>
                Resolving customer-facing issues, e.g. any breaking changes that affect the customer. Through Firebase Crashlytics we can see daily reports of any crashes that we may not have seen during the development and testing phase.
            </li>
            <li>
                Delivering the app end-to-end including uploading to the Play Store, e.g. I contribute to any releases we have.
            </li>
            <li>
                Making key high-level decisions including any architectural changes e.g. I was responsible for moving the app from an MVP architecture to an MVVM architecture. I was a key player in making sure our test suite was running and reporting accurate coverage, reducing tech debt by half in the first 3 months of joining.
            </li>
            <li>
                Bringing awareness to other teams issues that may impact the mobile team, e.g. the API team may make some change that will break the Android and iOS apps.
            </li>
            <li>
                Working in tandem with the iOS and others teams to ensure the app is kept in-sync with them all, e.g. for any new features, I must work with our product owners and the communications team to bring a new feature to market.
            </li>
            <li>
                Helping new developers with any problems they have with the app, e.g any new developer thats onboarded, I support them. I have wrote our own documentation pages to help learning about the codebase easier.
            </li>
            <li>
                Helped in interviewing candidates.
            </li>
        </ul>
    </div>,
    [],
    [new Button("Go to app", "https://play.google.com/store/apps/details?id=com.freeagent.mobile&hl=en_GB")]
);


export const hsbc = new Exp(
    "HSBC",
    "hsbc.jpg",
    "Mobile Developer",
    "April 2019 to December 2021",
    <div>
        <p>
            As a Mobile Developer at HSBC, I am in charge of all 26+
            apps built by HSBC and its group members (which includes HSBC UK, HSBC UAE, First Direct and
            M&S Bank and loads of other apps).
        </p>
        <ul>
            <li>
                Within a year I quickly rose up the ranks and became code maintainer of all of the apps
                and several very critical internal libraries.
            </li>
            <li>
                Refactored all of the copy inside one module. Became the defacto go-to developer
                for internationalisation and Gradle module topics.
            </li>
            <li>
                Created documentation that improved productivity for the consumption of HSBC's
                global developer community.
            </li>
            <li>
                Recognised by management for outstanding contributions helping the whole of
                the global HSBC developer community.
            </li>
            <li>
                Led the charge against the most difficult problem in Android - we hit
                the 64K strings limit.
            </li>
        </ul>
    </div>
);


export const snapsales = new Exp(
    "Snapsales",
    "snapsales.png",
    "Android Lead",
    "September 2018 to April 2019",
    <div>
        <p>
            At Snapsales I built an app called <a href="https://play.google.com/store/apps/details?id=com.snapsales.dscvr">Dscvr</a>,
            which is a hyper-local real-time discounts app, freshly released to the app store. I was
            in charge of building the whole native Android app from scratch to bring it into
            feature parity with the iOS app. I had to wear many hats but primarily operated on the front end Android app.
            3 months in, I advocated the use of Flutter. This allowed Snapsales to progress faster as
            Flutter works on both iOS and Android so there was less development time needed.
        </p>
        <ul>
            <li>Worked closely with Android technologies.</li>
            <li>More practice being part of a small but growing team.</li>
            <li>Advocated the use of various technologies so that we can get to market fast.</li>
            <li>Worked to business requirements.</li>
            <li>Worked with bluetooth technologies.</li>
            <li>Launched the app on the Play Store.</li>
        </ul>

    </div>,
    [dscvr]
);


export const laal = new Exp(
    "Gurpreet.co",
    "g.png",
    "Freelancer",
    "Jan 2011-ish to Present",
    <div>
        <p>
            I've been doing some contract work on various projects. Sometimes advising
            charities on their digital strategy.
        </p>
        <ul>
            <li>Consulting and meeting clients on a one-to-one basis.</li>
            <li>Assisting and helping charities and small businesses decipher complex development contracts.</li>
            <li>Using remote tools like Slack and Google Meet to work.</li>
            <li>Creating high quality software.</li>
            <li>Giving up-to-date advice on modern tools to use.</li>
            <li>Refactoring and language advice.</li>
        </ul>
    </div>,
    [systraApp, fupp, l4dDoorLock]
);


export const googleTech = new Exp(
    "Google",
    "google.gif",
    "Google Technician",
    "March 2015 to October 2015",
    <div>
        <p>
            Google were in Leeds to help SMEs with their
            digital presence. I was part of the first ever team of Garagers.
            A whole range of topics were discussed in each consultation session
            that lasted approximately 60 minutes. Everything from Google Analytics, Google Adwords,
            Google My Business and Social Media. Business owners would ask strategy and heavily contextual
            questions based on what their situation was.
        </p>
        <ul>
            <li>Representing Google being a public face for the global company.</li>
            <li>Dealing with the press and local news outlets.</li>
            <li>Talking to business owners at a high level.</li>
            <li>Tailored advice for each business on their website and social media.</li>
            <li>Resolving technical problems with Google products such as Analytics and AdWords.</li>
            <li>Mentoring people on Google My Business.</li>
            <li>In-depth understanding of Google PageRank.</li>
        </ul>
    </div>,
    [],
    []
);


export const googleTechOnTour = new Exp(
    "Google",
    "google.gif",
    "Google on Tour Technician",
    "March 2015 to October 2015",
    <div>
        <p>
            I led the first ever Digital Garage on Tour. It was much like
            the above role but rather than businesses coming to the garage,
            we would meet businesses where they were situated.
        </p>
        <ul>
            <li>Representing Google professionally on-foot.</li>
            <li>Helping to organise, plan and stress-test the first ever On Tour programme.</li>
            <li>Led a team of 2 talking to small to medium businesses.</li>
            <li>Friendly and affable attitude was required.</li>
            <li>Positive and fast-thinking was required to talk to business owners who were often very busy.</li>
            <li>Gave critical feedback to Google who would use the data to feed into the next DGoT programme.</li>
        </ul>
    </div>,
    [],
    []
);

export const pbc = new Exp(
    "PinBellCom",
    "pbc.png",
    "Jr Software Developer",
    "July 2014 to March 2015",
    <div>
        <p>
            Worked as a part of a team that developed several mobile apps for the NHS
            (specifically GP surgeries) and Marks and Spencer. I was
            quickly given ownership of the two projects which were developed within 2 months altogether.
            The apps were deployed on the iOS App Store and the Google Play Store.
        </p>
        <p>
            The M&S app called "Incidents" is still, to my knowledge, being used
            nationwide. The NHS app called "Intradoc 24/7" is now formalised as part of
            the Intradoc 24/7 suite of software. Although my contract officially ended in March 2015,
            I worked for PinBellCom during my university summer holidays and then was put on a zero hour contract
            in the hope that I would return to employment with PinBellCom. However, I did not return as university kept
            me busy.
        </p>
        <ul>
            <li>Developed and worked on several APIs which allowed communication between the AJAX apps and SQL servers.</li>
            <li>PHP, HTML and CSS were used for the backend and Ionic with AngularJS was used for the frontend.</li>
            <li>Learnt and used HTTP GET, POST and auth tokens.</li>
            <li>Undertook demos and presentations to M&S.</li>
        </ul>
    </div>,
    [mandsIncidents, intradocChecklists],
    []
);


export const ictTechnician = new Exp(
    "Allerton High School",
    "ahs.gif",
    "ICT Technician",
    "July 2013 to Oct 2013",
    <div>
        <p>
            Mounted new desktop computers and removed old computers manually.
            Created images of Windows 7 Professional.
            The Windows 7 images had to be compatible with desktop and laptop machines. Then they were installed onto
            hundreds of computers manually.
            Fixed a range of computers around the school as some of them were in disrepair.
        </p>
        <ul>
            <li>Working as part of a team to un-mount and mount hundreds of computers from their bases several times over.</li>
            <li>Created a base image that was to be installed everywhere.</li>
            <li>Helped do all the manual work of carrying trolley loads of laptops and making sure they all worked.</li>
            <li>Massive patience was involved in testing every laptop and computer.</li>
            <li>Listened to direct manager and worked to maintain a good IT presence for teachers and admin staff.</li>
        </ul>
    </div>,
    [],
    [new Button("Go to site", "https://www.allertonhigh.org.uk/")]
);

export const reprographicsTechnician = new Exp(
    "Allerton High School",
    "ahs.gif",
    "Reprographics Technician",
    "July 2013 to Oct 2013",
    <div>
        <p>
            Did this alongside the above job.
            Organised and printed the school's work for teachers and administrators.
            Maintained and checked printers using networking software. Helped resolve
            common printing issues around the school. Did a lot of booklet, binding, laminating and holepunching work.
        </p>
        <ul>
            <li>Copied and printed the whole school's documents.</li>
            <li>Use of organisational skills to coordinate this undertaking.</li>
            <li>Timing was essential.</li>
            <li>Communicating as to how long a print would take was crucial.</li>
            <li>A good attitude to the job was required because of the large amount of teachers and students that
                were being served.</li>
        </ul>
    </div>,
    [],
    [new Button("Go to site", "https://www.allertonhigh.org.uk/")]
);


export const itEngineer = new Exp(
    "Westcom Networks",
    "westcom.png",
    "IT Engineer",
    "June 2012 to July 2012",
    <div>
        <p>
            A hands on job role in which I travelled to and worked in many places such as London and York. This role required me to:
        </p>
        <ul>
            <li>Build servers from scratch; this included the physical building of the servers.</li>
            <li>It was expected that I had reasonable knowledge of the workings of computers.</li>
            <li>Install VMWare onto the servers.</li>
            <li>Check the integrity of wireless networks around schools using a diagnostic app.</li>
        </ul>
    </div>,
    [],
    [new Button("Go to site", "https://www.westcomnetworks.co.uk/")]
);

export const boots = new Exp(
    "Boots Pharmacy",
    "boots.png",
    "Assistant Chemist",
    "Oct 2011 to Oct 2011",
    <div>
        <p>
            As part of my high school work experience, I went to work in a chemist near my
            home town.
        </p>
        <ul>
            <li>Stocked shelves and monitored stock inside the chemist.</li>
            <li>Helped pharmacists with small tasks.</li>
            <li>Managed the till from time-to-time.</li>
            <li>Used the POS.</li>
        </ul>
    </div>,
    [],
    []
);


export const mgftw = new Exp(
    "Marvelous Gaming",
    "marvelous.jpg",
    "Head Administrator",
    "January 2010 to April 2013",
    <div>
        <p>
            I am ashamed to admit I was a heavy gamer throughout high school. I did not fit in
            at school and so online gaming was my only mental break. Because I was playing
            so much and so often, I was given the prestigious opportunity to become a Trial Administrator
            in an online community called Marvelous Gaming.
            I then became a Moderator, which then turned into Head Administrator. Head Administrator
            meant that I had full control over the game servers, the systems, the forums and everything else.
        </p>
        <p>
            With great power comes great responsibility. And boy was there responsibility.
            There were more than a thousand monthly players playing L4D2 on MG's servers
            which I had to monitor and manage - most of them
            older than me. I was to be level headed when handing out bans for griefing and racism. I
            was to be good at the game. I was to communicate effectively remotely with other admins.
            I also learnt how to code scripting plugins for the game.
            My parents had no hope for me in future as a result of my gaming. But it wasn't a negative for me,
            it was a positive. I learnt:
        </p>
        <ul>
            <li>People skills.</li>
            <li>How to communicate effectively remotely.</li>
            <li>Being mature.</li>
            <li>First steps in coding and scripting.</li>
            <li>Managing vBulletin and forum software.</li>
            <li>Installing SourceMod on servers.</li>
            <li>Creating server instances.</li>
            <li>Using SSH and linux commands.</li>
        </ul>
    </div>,
    [l4dDoorLock],
    []
);


export const projects = [
    dscvr,
    fupp,
    lazysodium,
    recordo,
    systraApp,
    googleGlass,
    crimeEye,
    smtwIos,
    smtwAndroid,
    mandsIncidents,
    intradocChecklists,
    princeTutti,
    mathematrics,
    raptshia,
    l4dDoorLock
];
